import React from 'react'
import IEventedComponent, { messageTypes } from '../components/IEventedComponent'
import { OpenReportErrorDialogEvent, CloseReportErrorDialogEvent } from '../lib/messages'
import Dialog from './dialog'
import Callout from '../components/callout'
import colours from '../lib/colours'
import styled from 'styled-components'

const CalloutContainer = styled.div`
  margin: -20px -40px 0;
  padding: 10px 20px 10px 15px;
  font-weight: 300;
`

interface IProps {
  open: boolean
}

interface IState {}

const ReportErrorDialog = class extends IEventedComponent<IProps, IState> {
  setOpenState(open: boolean) {
    open
      ? this.publish<OpenReportErrorDialogEvent>(messageTypes.onOpenReportErrorDialog)
      : this.publish<CloseReportErrorDialogEvent>(messageTypes.onCloseReportErrorDialog)
  }

  render() {
    const { open } = this.props

    return (
      <Dialog
        modal={true}
        open={open}
        showHeader={true}
        showFooter={true}
        setPopupState={this.setOpenState.bind(this)}
        heading="Error Generating report"
      >
        <CalloutContainer style={{ backgroundColor: colours.lightGreenBackground }}>
          <Callout type="warning">
            <p>There was an error generating the Levy Liability Details report. Please check that your internet browser's pop-ups are enabled. </p>
            <p style={{ wordBreak: 'break-word' }}>
              If the error persists, please contact{' '}
              <a href="mailto:msa.habitatcompensation@delwp.vic.gov.au">msa.habitatcompensation@delwp.vic.gov.au</a> for
              further assistance.
            </p>
          </Callout>
        </CalloutContainer>
      </Dialog>
    )
  }
}

export default ReportErrorDialog
